import { useCallback, useState } from "react";
import { translate as translateText } from "./request/translate";
export const useTranslate = () => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const translate = useCallback((text) => {
        setLoading(true);
        translateText(text)
            .then((response) => {
            setResult(response);
            setLoading(false);
        })
            .catch((error) => {
            setError(error.message);
            setLoading(false);
        });
    }, []);
    return { loading, result, error, translate };
};
